module.exports = __webpack_public_path__ + "static/media/icon_rw.8a96c81b.png";